<script lang="ts" setup>
import type {Question} from '@/ts/types/dto/interventions-dto';
import {useUserStore} from '@/ts/store/user-store';
import {useUnitConversion} from '@/ts/composables/pure/use-unit-conversion';
import {useProfileDateFormat} from '@/ts/composables/stateful/use-profile-date-format';
import {formatZipCode} from '@/ts/utils/pure-functions';
import {computed} from 'vue';

const props = defineProps<{
  answer: number | null;
  question: Question;
}>();

const {userData} = useUserStore();
const {formatWeight, formatHeight} = useUnitConversion({
  countryCode: userData?.countryCode,
  locale: useProfileDateFormat().value.numberLocale,
});

const formattedAnswer = computed(() => {
  const format = props.question.numeric?.format;
  const hasAnswer = typeof props.answer === 'number';

  if (format === 'weight' && hasAnswer) {
    // Answer is stored in grams, format with units
    return formatWeight(props.answer);
  } else if (format === 'height' && hasAnswer) {
    // Answer is stored in centimeters, format with units
    return formatHeight(props.answer);
  } else if (format === 'zipcode' && hasAnswer) {
    // Numeric input strips leading zeros; reconstruct the 5-digit ZIP for display
    return formatZipCode(props.answer);
  }

  // Default numeric display
  if (hasAnswer) {
    return props.answer.toString();
  }

  return '';
});
</script>

<template>
  <div>{{ formattedAnswer }}</div>
</template>
<style lang="scss" scoped>

</style>
